<form [formGroup]="quizForm">
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <div>
          <h2>Generate Assessment Link</h2>
          <p>
            A unique URL will be auto-generated for
            <b>{{ quizEditForm.get("quiz_name")?.value || "this quiz" }}</b
            >.
          </p>
        </div>
        <span class="close-btn" (click)="closeDialog()">
          <i class="bi bi-x"></i>
        </span>
      </div>

      <div class="modal-body">
        <div class="section">
          <label class="section-title">LINK DETAILS</label>

          <label class="link-name">Link Name <span class="req">*</span></label>
          <input
            type="text"
            placeholder="link name"
            formControlName="link_name"
          />
          <small>Internal label to identify this link.</small>
        </div>

        <ng-container *hasPermission="PermissionForStudents.MOCK_TEST">
        <div class="publish-mock-test-section">
          <div class="publish-mock-test-card">
            <div class="publish-card-top">
              <div class="publish-card-info">
                <h3>Publish as Mock Test</h3>
                <p>
                  Make this assessment available as a public mock test on the
                  BeExpert platform.
                </p>
              </div>
            </div>

            <div class="publish-card-bottom">
              <span class="publish-toggle-label"> Publish as Mock Test </span>

              <label class="publish-toggle">
                <input
                  type="checkbox"
                  [checked]="isPublishedAsMockTest"
                  (change)="togglePublishAsMockTest($event)"
                />

                <span class="publish-toggle-slider"></span>
              </label>
            </div>
          </div>

          <div *ngIf="isPublishedAsMockTest" class="mock-test-fields">
            <div class="form-field">
              <label> Company Name <span>*</span> </label>

              <input
                type="text"
                placeholder="Enter company name"
                formControlName="company_name"
              />
              <small
                class="text-danger smaller-text"
                *ngIf="
                  quizForm.get('company_name')?.touched &&
                  quizForm.get('company_name')?.hasError('required')
                "
              >
                Company Name is required
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (quizForm.get('company_name')?.dirty ||
                    quizForm.get('company_name')?.touched) &&
                  quizForm.get('company_name')?.hasError('minLengthName')
                "
              >
                Company Name must be at least 2 characters long.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (quizForm.get('company_name')?.dirty ||
                    quizForm.get('company_name')?.touched) &&
                  quizForm.get('namcompany_namee')?.hasError('invalidName')
                "
              >
                Please enter a valid company name. Company Name can contain only
                letters, spaces, apostrophes, periods and hyphens.
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (quizForm.get('company_name')?.dirty ||
                    quizForm.get('company_name')?.touched) &&
                  quizForm.get('company_name')?.hasError('maxLengthName')
                "
              >
                Maximum 100 characters allowed</small
              >
            </div>

            <div class="form-field">
              <label> Company Logo <span>*</span> </label>

              <div class="company-logo-upload">
                <div class="upload-icon" *ngIf="!logoPreview"></div>

                <div class="upload-text" *ngIf="!logoPreview">
                  <span>Upload the company logo</span>
                </div>

                <div class="logo-preview" *ngIf="logoPreview">
                  <img [src]="logoPreview" alt="Company logo" />
                </div>

                <label class="browse-btn">
                  {{ logoPreview ? "Change" : "Browse" }}

                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    (change)="onCompanyLogoSelected($event)"
                  />
                </label>
              </div>
            </div>

            <div class="form-field">
              <label> Role Name <span>*</span> </label>

              <input
                type="text"
                placeholder="Enter role name"
                formControlName="role_name"
              />
              <small
                class="text-danger smaller-text"
                *ngIf="
                  quizForm.get('role_name')?.touched &&
                  quizForm.get('role_name')?.hasError('required')
                "
              >
                Role is required
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (quizForm.get('role_name')?.dirty ||
                    quizForm.get('role_name')?.touched) &&
                  quizForm.get('role_name')?.hasError('minLengthName')
                "
              >
                Role must be at least 2 characters long.
              </small>

              <small
                class="text-danger smaller-text"
                *ngIf="
                  (quizForm.get('role_name')?.dirty ||
                    quizForm.get('role_name')?.touched) &&
                  quizForm.get('role_name')?.hasError('invalidName')
                "
              >
                Please enter a valid role name. Role Name can contain only
                letters, spaces, apostrophes, periods and hyphens.
              </small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  (quizForm.get('role_name')?.dirty ||
                    quizForm.get('role_name')?.touched) &&
                  quizForm.get('role_name')?.hasError('maxLengthName')
                "
              >
                Maximum 100 characters allowed</small
              >
            </div>

            <div class="form-field">
              <label> Test Category <span>*</span> </label>

              <select formControlName="test_category">
                <option value="" disabled selected>Select test category</option>

                <option value="All">All</option>
                <option value="Technical">Technical</option>
                <option value="Management">Management</option>
                <option value="General">General</option>
              </select>
            </div>
          </div>
        </div>
      </ng-container>
        <div class="section">
          <label class="section-title">AUDIENCE</label>

          <div class="option active">
            <input
              type="radio"
              formControlName="specific_candidates"
              value="invite"
            />
            <div>
              <b>Invite Specific Candidates</b>
              <p>Restrict access to invited email addresses.</p>
            </div>
          </div>
          <div
            class="group-box"
            *ngIf="quizForm.get('specific_candidates')?.value === 'independent'"
          >
            <label class="section-title">Select User Groups & Users</label>

            <div class="dropdown-display" (click)="toggleDropdown()">
              <span *ngIf="selectedGroups.length === 0">
                Select user groups
              </span>

              <span *ngIf="selectedGroups.length > 0">
                {{ selectedGroups.length }} groups · 0 users selected
              </span>

              <i class="bi bi-chevron-down"></i>
            </div>

            <div class="dropdown-panel" *ngIf="isDropdownOpen">
              <input
                type="text"
                placeholder="Search groups or users..."
                [(ngModel)]="searchText"
              />

              <div class="dropdown-item" *ngFor="let g of filteredGroups">
                <input
                  type="checkbox"
                  [checked]="selectedGroups.includes(g.id)"
                  (change)="onCheckboxChange(g.id, $event)"
                />
                <span>{{ g.name }}</span>
              </div>
            </div>

            <div class="chips-container" *ngIf="selectedGroups.length > 0">
              <div class="selected-title">
                SELECTED ({{ selectedGroups.length }})
              </div>

              <div class="chip-row">
                <span class="chip me-2" *ngFor="let g of selectedGroups">
                  <i class="bi bi-people"></i>
                  {{ getGroupName(g) }}
                  <i class="bi bi-x-lg" (click)="removeGroup(g)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="bulk-email-box">
          <p class="title">Bulk add candidate emails</p>

          <textarea
            rows="4"
            placeholder="e.g. alice@example.com, bob@example.com"
            formControlName="invited_emails"
          >
          </textarea>

          <div class="bottom-row">
            <span class="hint"> Separate by commas, spaces or new lines </span>

            <span
              [matTooltip]="
                !quizForm.get('invited_emails')?.value?.trim() &&
                invitedEmailList.length === 0
                  ? 'Please enter at least one email address'
                  : ''
              "
            >
              <button
                class="btn-add"
                type="button"
                (click)="addEmails()"
                [disabled]="
                  !quizForm.get('invited_emails')?.value?.trim() &&
                  invitedEmailList.length === 0
                "
              >
                <i class="bi bi-envelope me-1"></i>
                Add to invite list
              </button>
            </span>
            <div class="chips-container" *ngIf="invitedEmailList.length > 0">
              <div class="selected-title">
                EMAILS ({{ invitedEmailList.length }})
              </div>

              <div class="chip-row">
                <span class="chip" *ngFor="let email of invitedEmailList">
                  <i class="bi bi-envelope"></i>
                  {{ email }}
                  <i class="bi bi-x-lg" (click)="removeEmail(email)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="validity-box">
          <label class="section-title">VALIDITY (UTC)</label>

          <div class="row">
            <div class="field">
              <label class="link-name"
                >Start date <span class="req" *ngIf="!isPublishedAsMockTest">*</span></label
              >
              <input
                type="datetime-local"
                formControlName="start_date"
                [attr.min]="minDateTime"
              />
              <small>Defaults to now</small>
            </div>

            <div class="field">
              <label class="link-name"
                >End date <span class="req" *ngIf="!isPublishedAsMockTest">*</span></label
              >
              <input type="datetime-local" formControlName="end_date" />
              <small>Used to compute expiry</small>
              <small
                class="text-danger smaller-text"
                *ngIf="
                  quizForm.errors?.['invalidDateRange'] &&
                  quizForm.get('end_date')?.touched
                "
              >
                End date must be at least 2 minutes after start date
              </small>
            </div>
          </div>

          <div class="field expiry-field mt-3">
            <label class="link-name">
              <i class="bi bi-clock"></i> Expiry in (hours)
            </label>

            <div class="input-wrapper">
              <input
                type="text"
                placeholder="24 h"
                formControlName="expire_in_hours"
                readonly
              />
              <span class="auto-tag">Auto calculated</span>
            </div>
          </div>
          <p class="note">Defaults to 24h when no end date is set.</p>
        </div>

        <label class="section-title">RULES</label>
        <div class="rules-box">
          <div class="rules-row">
            <div class="rules-text">
              <h3>Use default settings</h3>
              <p>
                Inherit all settings from the assessment. Turn off to customize
                settings specifically for this link only.
              </p>
            </div>

            <div class="rules-toggle">
              <label class="switch">
                <input type="checkbox" formControlName="use_default_settings" />
                <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="isSettingsExpanded" [formGroup]="quizEditForm">
          <div class="quiz-modal mt-3">
            <div class="qm-body">
              <div class="qm-section">
                <div class="qm-sec-head">
                  <div class="step">1</div>
                  <div>
                    <div class="sec-title">
                      <i class="bi bi-card-text me-2"></i>
                      Quiz details
                    </div>
                    <div class="sec-sub">
                      Give your quiz a clear name and description
                    </div>
                  </div>
                </div>

                <div class="qm-content">
                  <div class="field-group">
                    <label class="field-label">
                      Quiz Title <span class="req">*</span>
                    </label>
                    <input
                      formControlName="quiz_name"
                      placeholder="e.g Placement KickStart Quiz"
                    />
                  </div>
                </div>
              </div>
              <div class="qm-section">
                <div class="qm-sec-head">
                  <div class="step">2</div>
                  <div>
                    <div class="sec-title">
                      <i class="bi bi-sliders me-2"></i>
                      Configuration
                    </div>
                    <div class="sec-sub">
                      Control how students experience the quiz
                    </div>
                  </div>
                </div>

                <div class="qm-content grid-2">
                  <div class="field-group">
                    <label class="field-label">Duration</label>

                    <div class="time-input">
                      <input
                        formControlName="hh"
                        placeholder="HH"
                        maxlength="2"
                      />
                      <span>:</span>
                      <input
                        formControlName="mm"
                        placeholder="MM"
                        maxlength="2"
                      />
                      <span>:</span>
                      <input
                        formControlName="ss"
                        placeholder="SS"
                        maxlength="2"
                      />
                    </div>
                  </div>

                  <div class="field-group"  *ngIf="!isPublishedAsMockTest">
                    <label class="field-label"
                      >Attempts Allowed <span class="req">*</span></label
                    >
                    <input type="number" formControlName="attempts_allowed" />
                  </div>

                  <div class="field-group">
                    <label class="field-label">Passing Score (%)</label>
                    <input type="number" formControlName="passing_score" />
                  </div>

                  <div class="field-group">
                    <label class="field-label"
                      >Questions per User <span class="req">*</span></label
                    >
                    <input type="number" formControlName="questions_per_quiz" />
                  </div>
                </div>

                <div class="divider"></div>

                <div class="toggle-row">
                  <span class="title">Shuffle questions</span>
                  <label class="switch">
                    <input
                      type="checkbox"
                      formControlName="shuffle_questions"
                    />
                    <span class="slider"></span>
                  </label>
                </div>

                <div class="toggle-row">
                  <span class="title">Shuffle options</span>
                  <label class="switch">
                    <input type="checkbox" formControlName="shuffle_options" />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>

              <div class="qm-section">
                <div class="qm-sec-head">
                  <div class="step">3</div>
                  <div>
                    <div class="sec-title">
                      <i class="bi bi-shield-check me-2"></i>
                      Proctoring
                    </div>
                    <div class="sec-sub">
                      Enable monitoring to maintain quiz integrity
                    </div>
                  </div>
                </div>

                <div class="toggle-row">
                  <div>
                    <div class="title">Enable proctoring</div>
                    <div class="sec-sub">
                      {{
                        quizEditForm.get("isProctored")?.value
                          ? "Proctored — monitoring active"
                          : "Non-proctored — no monitoring"
                      }}
                    </div>
                  </div>

                  <label class="switch">
                    <input type="checkbox" formControlName="isProctored" />
                    <span class="slider"></span>
                  </label>
                </div>

                <!-- <div
                  class="option-row"
                  *ngFor="let option of proctorOptions"
                  (click)="toggleOption(option)"
                > -->
                <div
                  class="option-row"
                  *ngFor="let option of proctorOptions"
                >
                  <i
                    class="bi bi-check-lg"
                    [class.active]="selectedOptions.includes(option)"
                  ></i>
                  <span>{{ option }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="generate-btn cancel"
          type="button"
          (click)="closeDialog()"
        >
          Cancel
        </button>
        <button
          class="generate-btn"
          type="button"
          [disabled]="!isFormValid || isLoading"
          (click)="postGenerativeLink()"
        >
          <ng-container *ngIf="isLoading; else showText">
            <span class="spinner-text">
              <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>
              Generating...
            </span>
          </ng-container>
          <ng-template #showText>
            <i class="bi bi-link-45deg"></i> Generate Link
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</form>
